var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWaveRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 6,
    viewBox: "0 0 48 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.367188 1C4.25819 1 4.25819 4.662 8.15219 4.662C12.0452 4.662 12.0452 1 15.9412 1C19.8362 1 19.8362 4.662 23.7302 4.662C27.6242 4.662 27.6252 1 31.5192 1C35.4152 1 35.4152 4.662 39.3142 4.662C43.2092 4.662 43.2092 1 47.1072 1",
    stroke: "#FF869E",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWaveRed);
export default __webpack_public_path__ + "static/media/email-wave-red.8b0235568c10e6a8c67bf9ccd86dc954.svg";
export { ForwardRef as ReactComponent };